<div class='tv-container'>
  <!-- Persistent components, available at any moment -->
  <remote-control></remote-control>
  <player></player>

  <!-- Page specific components via router-outlet -->
  <router-outlet></router-outlet>
</div>
